import { combineReducers } from '@reduxjs/toolkit'

//admin
import adminSettingReducer from '../admin/redux/settings/slice'
import adminNavReducer from '../admin/redux/nav/slice'
import adminAuthReducer from '../admin/redux/auth/slice'
import adminProviderManagement from '../admin/redux/providerManagement/slice'
import adminCMS from '../admin/redux/cms/slice'
import adminManagePharmacy from '../admin/redux/managePharmacy/slice'

//main
import mainAuthReducer from '../main/redux/auth/slice'
import mainProviderManagement from '../main/redux/providerManagement/slice'

//doctor
import doctorAuthReducer from '../doctor/redux/auth/slice'

//hospital
import hospitalAuthReducer from '../hospital/redux/auth/slice'

//lab
import labAuthReducer from '../lab/redux/auth/slice'

//patient
import patientAuthReducer from '../patient/redux/auth/slice'

// Manage pharmacy in pharmacy

import pharmacyManagePharmacy from '../pharmacy/redux/managePharmacy/slice'
import pharmacyAuthReducer from '../pharmacy/redux/auth/slice'
import pharmacyNavReducer from '../pharmacy/redux/nav/slice'

// Laboratory
import laboratoryAuthReducer from '../laboratory/redux/auth/slice'
import laboratoryNavReducer from '../laboratory/redux/nav/slice'
import manageLaboratory from '../laboratory/redux/manageLaboratory/slice'

// Scan Center

import scanCenterAuthReducer from '../scanCenter/redux/auth/slice'
import scanCenterNavReducer from '../scanCenter/redux/nav/slice'
import manageScanCenter from '../scanCenter/redux/manageScanCenter/slice'

const appReducer = combineReducers({
  adminNavReducer,
  adminAuthReducer,
  adminSettingReducer,
  adminProviderManagement,
  adminManagePharmacy,
  adminCMS,
  mainAuthReducer,
  mainProviderManagement,
  doctorAuthReducer,
  hospitalAuthReducer,
  labAuthReducer,
  patientAuthReducer,
  //pharmacy
  pharmacyAuthReducer,
  pharmacyManagePharmacy,
  pharmacyNavReducer,
  // laboratory
  laboratoryAuthReducer,
  laboratoryNavReducer,
  manageLaboratory,
  // scan-center
  scanCenterAuthReducer,
  scanCenterNavReducer,
  manageScanCenter,
})

const rootReducer = (state, action) => {
  if (action?.type === 'auth/userLogout') {
    return appReducer(undefined, action)
  }

  return appReducer(state, action)
}

export default rootReducer
